import microfrontendLayout from "./layout/microfrontend-layout.html";
import microfrontendLayoutLogin from "./layout/microfrontend-layout-login.html";
import { navigateToUrl } from "single-spa";
import { startSPA } from "./startFpp";
import { bootstrap as bootstrapNotifications } from "@newsenec/notifications";
import { bootstrap as bootstrapMicroFrontendManager } from "@newsenec/micro-frontend-manager";
import { getUser, logout } from "@newsenec/auth-provider";
import { overwriteKlaroConfigForControl } from "./overwriteKlaroConfigForControl";

export const startFpp = (): void => {
    overwriteKlaroConfigForControl();
    bootstrapNotifications()
        .then(bootstrapMicroFrontendManager)
        .then(() => startSPA(microfrontendLayout));
};
export const startWelcome = (): void => {
    startSPA(microfrontendLayoutLogin, false).then(() => navigateToUrl("/welcome"));
};
export const startFppRegistration = (): void => {
    startSPA(microfrontendLayoutLogin, false).then(() => navigateToUrl("/registration"));
};

export const startUnauthorized = (): void => {
    startSPA(microfrontendLayoutLogin, false).then(() => navigateToUrl("/unauthorized"));
};

export const startEmailVerification = (): void => {
    startSPA(microfrontendLayoutLogin, false).then(() => navigateToUrl("/verify-email"));
};
export const startRetryFppLogin = (): void => {
    startSPA(microfrontendLayoutLogin, false).then(() => navigateToUrl("/retry"));
};
export const startTermsApproval = (): void => {
    startSPA(microfrontendLayoutLogin).then(() => navigateToUrl("/terms-approval"));
};
export const forceLogout = (): void => {
    getUser().then((user) => (user ? logout(window.location.origin) : startWelcome()));
};
